import reserveApi from "../../../api/account/reserve";

const state = {
  list: {}
};

const getters = {};

const mutations = {
  // 存个列表
  setLst(state, { data }) {
    state.list = data;
  },
  // 修改收藏状态
  collect(state, { data }) {
    state.list.formatList.find(v => {
      if (v.propertyId == data.id) {
        if (data.type == "no") {
          v.favoritesFlag = "yes";
        } else {
          v.favoritesFlag = "no";
        }
      }
    });
  }
};

const actions = {
  // 获取列表
  getLst({ state }, { params, callback }) {
    console.log(state);
    reserveApi.getLstApi({ params, callback }, res => {
      callback(res);
    });
  },
  makeReservation({ state }, { params, callback }) {
    console.log(state);
    console.log("params", params);
    reserveApi.makeReservation({ params, callback }, res => {
      callback(res);
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/account/reserve.js